import { render, staticRenderFns } from "./RecentlyHot.vue?vue&type=template&id=6bf1915a&"
import script from "./RecentlyHot.vue?vue&type=script&lang=js&"
export * from "./RecentlyHot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports